// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__8Wjbk","checkbox":"TodoItem_checkbox__rGfev","textInput":"TodoItem_textInput__tG64E"};